const { default: AppConstants } = require("../gorillaboy/AppConstants");

(function () {
    'use strict';
    angular.module('GorillaBoy.directives')
        .directive('topBanner',
            ['$rootScope',
                'localStorageService',
                'AppConstants',
                function ($rootScope, localStorageService, AppConstants) {

                    return {
                        templateUrl: './top-banner/top_banner.html',
                        link: function (scope, element, attrs) {
                            scope.displayBanner = $rootScope.isBannerVisible();
                        }
                    };
                }
            ]
        )
}());
